import React from 'react';

export const ProjectPersonnelContext = React.createContext({});

export const useProjectPersonnelContext = () =>
  React.useContext(ProjectPersonnelContext);
